module.exports = __webpack_public_path__ + "img/trash-alt-solid.f2f64c1f.svg";